<template>
  <div class="card mt-2 mb-2 ms-5 me-5">
    <div class="card-body row">
      <div class="col-12 col-sm-5">
        <img :src="serverUrl + 'images/forms/' +
          imageFile" class="img-fluid img-thumbnail" :alt="'Imagen:' + imageInfo.imageName" />
      </div>
      <div class="container col-12 col-sm-7">
        <h4 class="mt-3 mb-3">Dimensiones del producto</h4>
        <div class="row">
          <div class="col-4">
            <label class="lblform mx-1">Longitud total:</label>
          </div>
          <div class="col-4">
            <input type="number" class="form-control mx-1 avilable-input" id="length" v-model="length" min="0"
              step="50" />
          </div>
          <div class="col-2">
            cm.
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
export const RUTA_SERVIDOR = process.env.VUE_APP_RUTA_BACKEND;
export default {
  watch: {
    length: {
      handler: "sendLength",
      deep: true,
    },
  },
  data() {
    return {
      serverUrl: RUTA_SERVIDOR,
      //Variables desde el store
      imageId: 0,
      imageFile: "",
      rawMatMainFamily: "",
      titleX: "Dimensiones del producto",
      //Info general de la imagen que almaceno luego de hacer get con el Id
      imageInfo: [],
      //Valor del largo del perfil con v-model
      length: 0,
    }
  },
  methods: {
    sendLength() {
      //console.log(this.imageInfo);
      this.$emit("sendProfileTubeImgInfo", this.imageInfo);
      this.$emit("sendLengthValue", this.length);
    },
  },
  beforeMount() {
    this.imageId = this.$store.getters.getImgId;
    this.imageFile = this.$store.getters.getImgFile;
    this.rawMatMainFamily = this.$store.getters.getRawMatFamily;
    if (this.rawMatMainFamily == "CANAL_U" || this.rawMatMainFamily == "VIGA_I" || this.rawMatMainFamily == "VIGA_H" || this.rawMatMainFamily == "ANGULO") {
      axios
        .get(RUTA_SERVIDOR + "api/profile/image/get", {
          params: {
            profileImg_id: this.imageId,
          },
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        })
        .then((res) => {
          this.imageInfo = res.data[0]
        })
        .catch((err) => console.error(`There has been an error ${err}`));
    } else if (this.rawMatMainFamily == "ESTRUCTURAL" || this.rawMatMainFamily == "MUEBLE") {
      axios
        .get(RUTA_SERVIDOR + "api/tube/image/get", {
          params: {
            tubeImg_id: this.imageId,
          },
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        })
        .then((res) => {
          this.imageInfo = res.data[0]
        })
    } else {
      console.log("Image form information doesn´t found!")
    }
  },
}
</script>
<style scoped>
.card {
  border: solid 2px #a6323b;
}

input [type="number"] {
  padding: 2px 6px 2px 16px;
  border: solid 5px #999999;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
}

.avilable-input {
  background-color: #FCE196;
}
</style>